import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  QuickCapturedDeliveriesResponse,
  QuickCapturedDeliveryAssignResponse
} from '../_models/quick-captured-delivery.interface';

@Injectable({
  providedIn: 'root'
})
export class QuickCapturedDeliveryService {
  private basePath = environment.apiURL + 'quick_captured_deliveries';

  constructor(private http: HttpClient) {}

  /**
   * Alle Schnellerfassungen abrufen
   * @param includeAssigned Auch bereits zugeordnete laden (default: false)
   */
  public getAll(includeAssigned: boolean = false): Observable<QuickCapturedDeliveriesResponse> {
    let params = new HttpParams();
    if (includeAssigned) {
      params = params.set('include_assigned', 'true');
    }
    return this.http.get<QuickCapturedDeliveriesResponse>(`${this.basePath}.json`, { params });
  }

  /**
   * Schnellerfassung einer bestehenden ExpectedDelivery zuordnen
   * @param quickCapturedId ID der Schnellerfassung
   * @param expectedDeliveryId ID der ExpectedDelivery
   */
  public assignToExisting(quickCapturedId: number, expectedDeliveryId: number): Observable<QuickCapturedDeliveryAssignResponse> {
    return this.http.post<QuickCapturedDeliveryAssignResponse>(
      `${this.basePath}/${quickCapturedId}/assign_to_existing.json`,
      { expected_delivery_id: expectedDeliveryId }
    );
  }

  /**
   * Gibt die URL für den PDF-Download zurück
   */
  public getPdfDownloadUrl(id: number): string {
    return `${this.basePath}/${id}/download_pdf`;
  }
}
